import type { SaveImageToLibraryOptions, SaveImageToLibraryResult } from './saveImageToLibrary'

export default async function saveImageToLibrary({
  filename,
  base64,
}: SaveImageToLibraryOptions): Promise<SaveImageToLibraryResult> {
  const blob = new Blob([Uint8Array.from(atob(base64), c => c.charCodeAt(0))], { type: 'image/png' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = `${filename}.png`
  a.click()

  URL.revokeObjectURL(url)

  return { success: true }
}
